import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';

import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter as Router } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <AuthProvider>
          {/* <React.StrictMode> */}
            <App />
          {/* </React.StrictMode> */}
        </AuthProvider>
      </Router>
    </PersistGate>
  </Provider>
);

reportWebVitals();
